
//EDUCATION : 
// need to do the update/add function
// refresh

import React from 'react';
import { CardSmall } from '../../../widgets/Cards';
import Confirm from '../../../widgets/Confirm';
import {connect} from 'react-redux';


import { fetchEducations, fetchEducation, editEducation, newEducation, deleteEducation} from '../../../../actions';

class Education extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showDelete : false,
            newForm : true,
            record : null,
        };
    };

    //Initial Rendering
    componentDidMount() {
        this.props.fetchEducations(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchEducations(this.props.patient._id)
        }   
    }

    renderEducationList() {

        return this.props.educations.map(education =>  {
     
            if ( education.privacy === false) {

                var tag = [];
                education.tag.map(pr => {
                    tag.push(pr.problem + ", ");
                    return null;
                })

                const rowButton = () => {
                    var permit = this.props.selectedPermission.permission[0].chronicdisease;
                    if (permit === "View only") {
                        return null;
                    } else { 
                        return (
                            <>
                            <button onClick={() => this.setState({showDelete: true, record: education._id})} className='tableDelete'><i className="fas fa-trash"></i></button>
                            </>
                        )
                    }  
                }


                return (
                        <tr key={education._id}>
                            <td><a href={education.link} target="blank">{education.title}</a></td>
                            <td>{education.status}</td>
                            <td>
                                {rowButton()}
                            </td>
                        </tr>
                        )
            };
            return null;
        })
    }

    buttons() {
        var permit = this.props.selectedPermission.permission[0].chronicdisease;
        if (permit === "View only") {
            return null
        } else { 
            return  <button onClick={() => this.setState({showModal: true, newForm: true, record: null})} className='btnew'>Add</button>
        }  
    }

    render() {
        return (
        
                <CardSmall title='Education Link(s)' buttons={this.buttons()}>
                    <table>
                        <thead>
                            <tr>
                                <th>Ttile</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody> 
                            {this.renderEducationList()}
                        </tbody> 
                    </table>
                    
                {this.renderDeleteBox()}
                </CardSmall>
        )
    }

    renderDeleteBox() {

        const handleDelete = () => {
            this.props.deleteEducation(this.state.record);
            this.setState({showDelete:false, record:null})
        }

        const deleteButtons = () => {
            return (
            <div>
                <button onClick={() => this.setState({showDelete: false})} className='btdel'>Cancel</button>
                <button onClick={handleDelete} className='btsave'>Ok</button>
            </div>
            )
        }

        return (
            <Confirm
                height='100px'
                width='300px'
                open={this.state.showDelete} 
                data={this.state.record}
                content="Delete this Education ?"
                title='Delete Education'
                actions = {deleteButtons()}
                onDismiss={() => this.setState({showDelete : false, record:null})}
            />
        )

    }

   

}

const mapStateToProps = (state) => {
    return { 
        patient : state.selectedPatient,
        educations : Object.values(state.educations),
        userId : state.auth.userId,
        selectedEducation : state.selectedEducation,
        selectedPermission : state.selectedPermission,
    }
}

export default connect(mapStateToProps, {fetchEducations, fetchEducation, editEducation, newEducation, deleteEducation})(Education);










    








